module.exports = __webpack_public_path__ + "static/media/RS.feea5bd2.png";